const Modal = ({modal}) => {

   return (
      <div id="modalBlog" className="modal modal-fixed-footer modal-blog margin-top-modal" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 15px 35px rgba(0,0,0,0.25)', maxHeight: '85vh' }}>
         <div className="modal-content" style={{ padding: '35px 30px', overflowY: 'auto' }}>
            <h4 style={{ color: '#039be5', fontWeight: '700', fontSize: '1.6rem', marginBottom: '20px', lineHeight: '1.3' }}>
               {modal?.blog_titulo}
            </h4>
            <div className="grey-text text-darken-3" style={{ fontSize: '1.05rem', lineHeight: '1.7' }} dangerouslySetInnerHTML={{ __html: modal?.blog_texto }}></div>
         </div>
         <div className="modal-footer" style={{ padding: '15px 30px', backgroundColor: '#fafafa', borderTop: '1px solid #eee', height: 'auto' }}>
            <button 
               type="button" 
               className="modal-close waves-effect waves-light btn red z-depth-0" 
               style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', height: '38px', lineHeight: '38px', padding: '0 20px' }}
            >
               Cerrar
            </button>
         </div>
      </div>
   )
}

export default Modal